<template lang="pug" src='./taskGadget.pug'></template>

<script>
import { VueTabs, VTab } from 'vue-nav-tabs'
import TaskGadgetTabContent from './TaskGadgetTabContent'

export default {
  name: 'TaskGadget',

  components: {
    VueTabs,
    VTab,
    TaskGadgetTabContent
  },

  props: {
    data: {
      type: Object
    },
    isLoadingDataTaskGadget: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      hasData: {
        tarefasPendentes: typeof this.data.quantidadePendenteMovFin === 'number' && typeof this.data.quantidadePendenteMovBan === 'number' && typeof this.data.totalQuantidadePendente === 'number',
        tarefasConciliadas: typeof this.data.quantidadeConcluidaMovFin === 'number' && typeof this.data.quantidadeConcluidaMovBan === 'number' && typeof this.data.totalQuantidadeConcluida === 'number'
      }
    }
  }
}
</script>

<style>
.gadgetTasks {
  font-family: 'Inter', sans-serif;
  background-color: #FFF;
  min-height: 400px;
}

.gadgetTasks>.tab {
  margin-top: 20px;
  border: none;
}

.gadgetTasks>.nav-tabs>li>a {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  text-transform: none;
  border: none;
}

.gadgetTasks>.vue-tabs .nav>li span.title {
  color: #012351;
  border: none;
}

.gadgetTasks>.vue-tabs .nav-tabs {
  border-bottom: none;
}

.gadgetTasks>.vue-tabs .nav-tabs>li>a {
  border: none;
}

.vue-tabs .nav-tabs-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {
  border-bottom: none!important;
}

.gadgetTasks>.vue-tabs .nav-tabs>li>a:hover {
  border: none;
}

.gadgetTasks>.vue-tabs .nav>li.active span.title {
  color: #39b8bb;
}

.gadgetTasks>.vue-tabs .nav-tabs>li.active>a,
.gadgetTasks>.vue-tabs .nav-tabs>li.active>a:hover,
.gadgetTasks>.vue-tabs .nav-tabs>li.active>a:focus {
  border: none;
  border-bottom: 5px solid #39b8bb!important;
  color: #012351;
  background: transparent;
  font-weight: 600;
  margin-bottom: -1px;
  border-radius: none
}

@media screen and (max-width: 1199px) {
  .gadgetTasks>.vue-tabs .nav-tabs-justified,
  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {
    border: none;
    bottom: 0;
    padding: 10px 10vw 0px 10vw;
    background-color: #F5F6FA;
    border: 1px solid #EAEEF4;
    border-top: none;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1399px) {
  .gadgetTasks>.vue-tabs .nav-tabs-justified,
  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {
    border: none;
    bottom: 0;
    padding: 10px 1vw 0px 1vw;
    background-color: #F5F6FA;
    border: 1px solid #EAEEF4;
    border-top: none;
  }
}

@media screen and (min-width: 1400px) and (max-width: 1599px) {
  .gadgetTasks>.vue-tabs .nav-tabs-justified,
  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {
    border: none;
    bottom: 0;
    padding: 10px 4vw 0px 4vw;
    background-color: #F5F6FA;
    border: 1px solid #EAEEF4;
    border-top: none;
  }
}

@media (min-width: 1600px) {
  .gadgetTasks>.vue-tabs .nav-tabs-justified,
  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {
    border: none;
    bottom: 0;
    padding: 10px 7vw 0px 7vw;
    background-color: #F5F6FA;
    border: 1px solid #EAEEF4;
    border-top: none;
  }
}

.gadgetTasks>.vue-tabs .nav-tabs>li>a,
.gadgetTasks>.vue-tabs .nav-tabs>li>a:hover,
.gadgetTasks>.vue-tabs .nav-tabs>li>a:focus {
  border: none;
}

@media (min-width: 768px) {
  .gadgetTasks>.vue-tabs .nav-tabs>li.active>a,
  .gadgetTasks>.vue-tabs .nav-tabs>li.active>a:hover,
  .gadgetTasks>.vue-tabs .nav-tabs>li.active>a:focus {
    border: none;
    border-bottom: 5px solid #39b8bb;
    color: #012351;
    background: transparent;
    font-weight: 600;
    margin-bottom: -1px;
    border-radius: none
  }
}

@media (min-width: 768px) {
  .gadgetTasks>.vue-tabs .gadgetTasks>.nav-justified>li,
  .gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs.nav-justified>li {
    display: table-cell;
    width: 1%;
  }
}

.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a,
.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a:hover,
.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a:focus {
  border: none;
  color: #012351;
  background: transparent;
  font-weight: 600;
  margin-bottom: -1px;
  padding-bottom: 13px;
}

.gadgetTasks>.tab-content {
  background: #fff;
}

.fa-task-gadget {
  font-size: 20px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// TaskGadget.vue?4b3d3850